module.exports = __webpack_public_path__ + "static/media/ConservativeSyllabus.1c352ee8.docx";